import React from "react";

const Contact = () => {
  return (
    <div>
      <li className="content-body">Questions? DM <a className="instagram cult-link" target="_blank" rel="noreferrer" href="https://instagram.com/lux_capacitor">@Lux_Capacitor</a><br/>or email us at <br/><a className="email cult-link" href="mailto:info@cultofneon.art">info@cultofneon.art</a></li>
      <br/>
    </div>
  );
};

export default Contact;